import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { formatValue } from '@ts-core/utils/dataTableUtils';
import Table, { TimeTableCell } from '@ts-core/components/Table';

import MediaItemThumbTableCell from '../../components/MediaItemThumbTableCell';

const StudentMediaStatsTable = (props) => {
  const intl = useIntl();
  const { onFetchStats, onFilterStats, onClickMediaItem, onGetXlsxData, xlsxFileName, mediaStats, loading, error } = props;
  const { totalViews, avgProgressPercentage, maxProgressPercentage, mediaItems = [] } = mediaStats;

  const columns = useMemo(
    () => [
      {
        Header: '',
        accessor: '_id',
        valueTransformer: (_value, _, mediaItem) => <MediaItemThumbTableCell mediaItem={mediaItem} />,
      },
      {
        Header: intl.formatMessage({ id: 'field.name.label' }),
        accessor: 'name',
      },
      {
        Header: intl.formatMessage({ id: 'subject' }),
        accessor: 'subject.name',
        id: 'subject.name',
        sortable: true,
        filterable: true,
      },
      {
        Header: intl.formatMessage({ id: 'mediaStatsTable.duration' }),
        accessor: 'duration',
        valueTransformer: (value) => <TimeTableCell time={value} />,
        sortable: true,
      },
      {
        Header: intl.formatMessage({ id: 'mediaStatsTable.totalViews' }),
        accessor: 'totalViews',
        Footer: totalViews ? `${totalViews}` : '-',
        sortable: true,
      },
      {
        Header: intl.formatMessage({ id: 'mediaStatsTable.avgProgress' }),
        accessor: 'avgProgressPercentage',
        valueTransformer: (value) => formatValue(value, 1),
        Footer: formatValue(avgProgressPercentage, 1, true, 1),
        sortable: true,
      },
      {
        Header: intl.formatMessage({ id: 'mediaStatsTable.maxProgress' }),
        accessor: 'maxProgressPercentage',
        valueTransformer: (value) => formatValue(value, 1),
        Footer: formatValue(maxProgressPercentage, 1, true, 1),
        sortable: true,
      },
    ],
    [intl, avgProgressPercentage, maxProgressPercentage, totalViews]
  );

  return (
    <Table
      // title={intl.formatMessage({ id: 'student.mediaStatsTable.title' })}
      data={mediaItems}
      columns={columns}
      loading={loading}
      errorMessage={error}
      onRefreshData={onFetchStats}
      onSearch={onFilterStats}
      onSelectRow={onClickMediaItem}
      allowDownloadAsXLSX
      xlsxFileName={xlsxFileName}
      getDataToExport={onGetXlsxData}
    />
  );
};

StudentMediaStatsTable.propTypes = {
  onFetchStats: PropTypes.func,
  onFilterStats: PropTypes.func,
  onClickMediaItem: PropTypes.func,
  onGetXlsxData: PropTypes.func,

  xlsxFileName: PropTypes.string,
  mediaStats: PropTypes.object,
  loading: PropTypes.bool,
  error: PropTypes.string,
};

StudentMediaStatsTable.defaultProps = {
  student: {},
  mediaStats: {},
  loading: false,
  error: undefined,
  onFetchStats: undefined,
  onFilterStats: undefined,
  onClickMediaItem: undefined,
  onGetXlsxData: undefined,
};

export default StudentMediaStatsTable;
